"use strict";
/*
 * Created on 5. 11. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Request for updating price code.
 * @author Radek Beran
 */


var PriceCodeUpdateRequest =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PriceCodeUpdateRequest, _DomainObject_1$Domai);

  /**
   * @param priceZoneId
   * @param priceCode the id of price code code book item
   */
  function PriceCodeUpdateRequest(priceZoneId, priceCode) {
    var _this;

    _classCallCheck(this, PriceCodeUpdateRequest);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceCodeUpdateRequest).call(this));
    _this.priceZoneId = priceZoneId;
    _this.priceCode = priceCode;
    return _this;
  }

  return PriceCodeUpdateRequest;
}(DomainObject_1.DomainObject);

exports.PriceCodeUpdateRequest = PriceCodeUpdateRequest;

PriceCodeUpdateRequest.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PriceCodeUpdateRequest.name);
  return {
    priceZoneId: builder.str('priceZoneId'),
    priceCode: builder.str('priceCode')
  };
}();